import React, {PureComponent} from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {cyan, grey} from '@material-ui/core/colors';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import RowsVisualizationPage from './components/rows-visualization/rows-visualization-page';

const theme = createMuiTheme({
    palette: {
        primary: { main: cyan[500] },
        secondary: { main: grey[500] },
    },
    typography: { useNextVariants: true },
});

function getRowsVisualizationPage() {
    return <RowsVisualizationPage/>;
}

class App extends PureComponent {
    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                <Router>
                    <Route exact path="/prime-interval-visualization/" component={getRowsVisualizationPage} />
                </Router>
            </MuiThemeProvider>
        );
    }
}

export default App;
